var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 143,
    viewBox: "0 0 143 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9674 49.7469V56.2422L73.721 80.3131V73.8155L31.9674 49.7469Z",
    fill: "#333232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.721 80.3131V73.8155L31.9674 49.7469",
    fill: "#333232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 46.5373L31.9674 49.8284L73.7177 73.8915L79.411 70.5991L37.6638 46.5373Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.411 70.5991L73.7211 73.8893V80.313L79.4209 77.022",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2316 60.4407C45.2316 49.9055 37.7957 37.01 28.7084 31.7668C23.8689 28.9739 19.5073 28.888 16.4965 31.0072L4.77966 37.7708V62.2181L17.1983 69.5904V57.6543C19.9745 62.4549 23.7092 66.6934 27.8316 69.3825V78.368L40.0191 71.3375V71.3352C43.2207 69.7033 45.2316 65.9204 45.2316 60.4407Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7084 31.7668C28.5218 31.6607 28.3408 31.5646 28.1553 31.4664L7.16241 43.5855V63.6301L17.198 69.5904V57.6542C19.9742 62.4549 23.7089 66.6934 27.8313 69.3825V78.368L40.0188 71.3374V71.3352C43.2208 69.7041 45.2328 65.9201 45.2328 60.4415C45.2316 49.9055 37.7957 37.0097 28.7084 31.7668Z",
    fill: "#070606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0177 71.3355C43.2196 69.7044 45.2316 65.9204 45.2316 60.4418C45.2316 54.7252 43.0375 48.3125 39.5808 42.8026L19.142 54.6012V60.682C21.62 64.2145 24.6016 67.278 27.8302 69.3828V78.3683L29.1799 77.5908V68.6711C30.4881 70.9366 32.0199 73.0718 33.7 74.9831L40.0188 71.3389V71.3355H40.0177Z",
    fill: "#070606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5156 76.9883C7.48211 71.7164 0.0459513 58.815 0.000281971 48.3371C-0.046522 37.8278 7.34907 33.5479 16.4285 38.784C25.5189 44.0315 32.9494 56.9417 32.9494 67.4522C32.9494 77.9748 25.5592 82.2692 16.5156 76.9883Z",
    fill: "#070606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4285 38.7829C25.5189 44.0303 32.9494 56.9406 32.9494 67.451C32.9494 77.9748 25.5592 82.2683 16.5156 76.9885",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5022 71.2997C10.161 67.5974 4.94052 58.5415 4.90932 51.1848C4.87471 43.8091 10.0674 40.8017 16.4432 44.4782C22.8245 48.1627 28.0396 57.2242 28.0396 64.6053C28.0404 71.9933 22.8534 75.0075 16.5022 71.2997Z",
    fill: "#B8C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4429 44.4782C22.8242 48.1627 28.0393 57.2242 28.0393 64.6054C28.0393 71.9933 22.8522 75.0075 16.5022 71.2995",
    fill: "#96AAA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.205 59.0541V65.5494L57.9575 89.6205V83.1227L16.205 59.0541Z",
    fill: "#333232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9575 89.6205V83.1227L16.205 59.0541",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9014 55.8445L16.205 59.1358L57.9552 83.1987L63.6486 79.9066L21.9014 55.8445Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6486 79.9066L57.9575 83.1964V89.6205L63.6574 86.3292",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6906 82.4604L83.6954 97.4776V111.01L57.6906 95.9907V82.4604Z",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6906 82.4604L83.6954 97.4776V111.01",
    fill: "#829093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6954 97.4776V111.01L102.285 100.283V86.7504L83.6954 97.4776Z",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.285 86.7504L83.6954 97.4776V111.01",
    fill: "#728284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6954 97.4776L102.285 86.7504L76.2717 71.7309L57.6906 82.4603L83.6954 97.4776Z",
    fill: "#5C6366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3561 62.7701L66.0514 71.2561V78.9021L51.3561 70.4159V62.7701Z",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3561 62.7701L66.0514 71.2561V78.9021",
    fill: "#829093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0515 71.256V78.9021L76.5554 72.8403V65.1931L66.0515 71.256Z",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5554 65.1931L66.0515 71.256V78.9021",
    fill: "#728284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0514 71.2561L76.5554 65.1931L61.8555 56.706L51.3561 62.7701L66.0514 71.2561Z",
    fill: "#5C6366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3561 53.0851L66.0514 61.5713V69.2182L51.3561 60.7311V53.0851Z",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3561 53.0851L66.0514 61.5713V69.2182",
    fill: "#829093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0515 61.5713V69.2182L76.5554 63.1564V55.5092L66.0515 61.5713Z",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5554 55.5092L66.0515 61.5713V69.2182",
    fill: "#728284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0514 61.5713L76.5554 55.5092L61.8555 47.0221L51.3561 53.0851L66.0514 61.5713Z",
    fill: "#5C6366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4468 16.9708V32.3591L57.8057 59.1335V43.7285L11.4468 16.9708Z",
    fill: "#2080F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9471 9.36163L11.4468 17.1643L57.7978 43.9197L71.3034 36.1151L24.9471 9.36163Z",
    fill: "#22ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3618 23.4094V38.7962L68.7204 65.5707V50.1659L22.3618 23.4094Z",
    fill: "#0D2C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8618 15.8002L22.3618 23.6014L68.7127 50.3568L82.2184 42.5522L35.8618 15.8002Z",
    fill: "#084F77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2184 42.5522L68.7204 50.3458V65.5707L82.2385 57.7672",
    fill: "#0B3A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6816 22.6262V38.013L85.0414 64.7886V49.3827L38.6816 22.6262Z",
    fill: "#0D2C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1816 15.0158L38.6816 22.8182L85.0337 49.5747L98.5394 41.7701L52.1816 15.0158Z",
    fill: "#084F77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5394 41.7701L85.0414 49.5625V64.7886L98.5595 56.9851",
    fill: "#0B3A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4559 72.9787L84.8394 83.5953V93.1617L66.4559 82.544V72.9787Z",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4559 72.9787L84.8394 83.5953V93.1617",
    fill: "#829093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8394 83.5953V93.1617L97.9808 85.5783V76.0119L84.8394 83.5953Z",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9808 76.0119L84.8394 83.5953V93.1617",
    fill: "#728284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8394 83.5953L97.9808 76.0119L79.592 65.3942L66.4559 72.9787L84.8394 83.5953Z",
    fill: "#5C6366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4559 60.863L84.8394 71.4796V81.046L66.4559 70.4295V60.863Z",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4559 60.863L84.8394 71.4796V81.046",
    fill: "#829093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8394 71.4796V81.046L97.9808 73.4626V63.8962L84.8394 71.4796Z",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9808 63.8962L84.8394 71.4796V81.046",
    fill: "#728284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8394 71.4796L97.9808 63.8962L79.592 53.2782L66.4559 60.863L84.8394 71.4796Z",
    fill: "#5C6366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.995 34.6125L134.143 38.1495L127.995 41.7321L121.846 38.1495L127.995 34.6125Z",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.846 38.1495L127.995 41.7321V103.882L121.846 100.332V38.1495Z",
    fill: "#576B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.846 38.1495L127.995 41.7321V103.882",
    fill: "#415556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.143 38.1495L127.995 41.7321V103.882L134.143 100.332V38.1495Z",
    fill: "#7E9091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.143 38.1495L127.995 41.7321V103.882",
    fill: "#728284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.038 115.788C141.038 105.254 133.602 92.3564 124.517 87.1143C119.678 84.3214 115.316 84.2355 112.305 86.3547L100.587 93.118V117.563L113.006 124.938V112.999C115.782 117.801 119.517 122.04 123.638 124.729V133.713L135.827 126.684V126.679C139.028 125.051 141.038 121.266 141.038 115.788Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.517 87.1147C124.331 87.0074 124.147 86.9113 123.964 86.8143L102.969 98.9322V118.976L113.005 124.937V112.999C115.782 117.801 119.516 122.039 123.638 124.728V133.713L135.826 126.683V126.679C139.028 125.049 141.038 121.264 141.038 115.786C141.038 105.253 133.602 92.3564 124.517 87.1147Z",
    fill: "#070606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.826 126.681C139.028 125.051 141.038 121.266 141.038 115.788C141.038 110.07 138.845 103.657 135.387 98.149L114.95 109.948V116.028C117.427 119.561 120.409 122.623 123.638 124.729V133.714L124.986 132.937V124.017C126.296 126.283 127.828 128.418 129.508 130.329L135.826 126.685V126.681Z",
    fill: "#070606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.323 132.336C103.291 127.062 95.8536 114.163 95.808 103.684C95.7612 93.1742 103.158 88.8944 112.236 94.1316C121.328 99.379 128.758 112.287 128.758 122.8C128.757 133.321 121.368 137.615 112.323 132.336Z",
    fill: "#070606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.236 94.1304C121.328 99.3779 128.758 112.286 128.758 122.799C128.758 133.322 121.369 137.616 112.324 132.336",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.311 126.647C105.968 122.945 100.748 113.889 100.718 106.531C100.683 99.1555 105.877 96.1481 112.252 99.8258C118.632 103.51 123.848 112.572 123.848 119.952C123.848 127.34 118.66 130.354 112.311 126.647Z",
    fill: "#B8C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.252 99.8246C118.632 103.509 123.848 112.571 123.848 119.951C123.848 127.339 118.66 130.354 112.311 126.646",
    fill: "#96AAA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6547 67.3481V77.2038L126.355 94.3539V84.4891L96.6547 67.3481Z",
    fill: "#2080F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.305 62.4716L96.6547 67.4689L126.352 84.6031L134.992 79.6047L105.305 62.4716Z",
    fill: "#064CB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.992 79.6048L126.355 84.6009V94.354L135.004 89.3556",
    fill: "#22ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1959 36.6603L93.5143 59.3659V79.8283L54.1959 57.1193V36.6603Z",
    fill: "#22ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1959 36.6603L93.5143 59.3659V79.8283",
    fill: "#2080F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5143 59.3659V79.8283L121.621 63.6077V43.1476L93.5143 59.3659Z",
    fill: "#064CB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.621 43.1476L93.5143 59.3659V79.8283",
    fill: "#0969C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5143 59.3659L121.621 43.1476L82.2899 20.4374L54.1959 36.6603L93.5143 59.3659Z",
    fill: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2899 20.4374L54.1959 36.6603L93.5143 59.3659",
    fill: "#64CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5519 30.7357L96.1696 41.4876V51.1758L77.5519 40.4239V30.7357Z",
    fill: "#2080F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1697 41.4876V51.1757L109.479 43.4962V33.8069L96.1697 41.4876Z",
    fill: "#064CB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1696 41.4876L109.479 33.8069L90.8541 23.0539L77.5519 30.7357L96.1696 41.4876Z",
    fill: "#64CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8541 23.0539L77.5519 30.7357L96.1696 41.4876",
    fill: "#22ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.513 31.3357H100.072V37.431C100.072 37.4443 100.072 37.4579 100.072 37.4701V37.6511H100.087C100.17 39.0978 101.155 40.53 103.057 41.6283C107.037 43.9274 113.549 43.9274 117.529 41.6283C119.432 40.53 120.414 39.0978 120.498 37.6511H120.514V31.3357H120.513Z",
    fill: "#728284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.057 41.6283C107.037 43.9274 113.549 43.9274 117.529 41.6283C119.432 40.53 120.414 39.0978 120.498 37.6511H120.514V31.3368H103.057V41.6283Z",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.528 26.7452C113.548 24.4473 107.036 24.4473 103.056 26.7452C99.0743 29.0431 99.0743 32.8025 103.056 35.1007C107.036 37.3986 113.548 37.3986 117.528 35.1007C121.508 32.8025 121.508 29.0431 117.528 26.7452Z",
    fill: "#576B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.057 35.1007C107.037 37.3986 113.549 37.3986 117.529 35.1007C121.509 32.8028 121.509 29.0434 117.529 26.7452",
    fill: "#415556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.328 40.2965C116.815 40.2965 116.315 40.0338 116.037 39.5593C115.617 38.8464 115.855 37.9294 116.566 37.5093L126.065 31.9121L125.989 26.8456C125.976 26.019 126.638 25.3374 127.463 25.3263C128.317 25.3621 128.97 25.9742 128.983 26.8011L129.071 32.7378L128.334 34.0494L118.086 40.0889C117.849 40.2296 117.586 40.2965 117.328 40.2965Z",
    fill: "#5C6366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.708 50.9848C106.708 44.8683 111.025 37.3819 116.299 34.3388C119.11 32.7154 121.643 32.6675 123.39 33.8974L130.19 37.8244V52.0171L122.983 56.297V49.3683C121.371 52.1555 119.203 54.6146 116.81 56.1753V61.3938L109.736 57.3116V57.3071C107.877 56.3628 106.708 54.1644 106.708 50.9848Z",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.299 34.3388C116.408 34.2753 116.514 34.2214 116.621 34.1612L128.812 41.2005V52.836L122.985 56.2969V49.3683C121.373 52.1555 119.204 54.6146 116.811 56.1753V61.3938L109.736 57.3116V57.3071C107.877 56.3619 106.708 54.1644 106.708 50.9848C106.708 44.8694 111.025 37.3819 116.299 34.3388Z",
    fill: "#728284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.736 57.3068C107.877 56.3616 106.708 54.1641 106.708 50.9846C106.708 47.6666 107.982 43.9418 109.988 40.7433L121.854 47.5917V51.1241C120.416 53.1719 118.684 54.9515 116.81 56.1738V61.3923L116.029 60.9388V55.7605C115.268 57.0767 114.379 58.3155 113.403 59.426L109.736 57.311V57.3068Z",
    fill: "#829093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.378 60.5916C128.625 57.5306 132.94 50.0419 132.968 43.9566C132.996 37.8556 128.701 35.3733 123.431 38.4119C118.15 41.4595 113.839 48.9513 113.839 55.0568C113.839 61.1646 118.128 63.6571 123.378 60.5916Z",
    fill: "#728284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.431 38.4119C118.15 41.4595 113.839 48.9513 113.839 55.0568C113.839 61.1645 118.128 63.6568 123.378 60.5913",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.387 57.288C127.067 55.1385 130.097 49.8834 130.116 45.6112C130.135 41.3302 127.121 39.584 123.42 41.7188C119.715 43.857 116.687 49.1189 116.687 53.4033C116.688 57.69 119.7 59.4407 123.387 57.288Z",
    fill: "#FFF5A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.421 41.7188C119.717 43.857 116.688 49.1189 116.688 53.4033C116.688 57.69 119.7 59.4405 123.387 57.2878",
    fill: "#EFE08B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.452 17.5708V24.5219L127.137 27.268V20.3036L122.452 17.5708Z",
    fill: "#A56F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.248 8.4043L122.452 17.5495L127.194 20.2857L143 11.1436L138.248 8.4043Z",
    fill: "#AD8461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 11.1436L138.248 8.4043L122.452 17.5495",
    fill: "#C99873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.973 20.2857V27.268L142.874 18.0905V11.1101L126.973 20.2857Z",
    fill: "#633C21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5898 52.5588L94.3508 51.2574V44.0014C94.3508 43.1748 95.0223 42.5042 95.8488 42.5042C96.6746 42.5042 97.346 43.1745 97.346 44.0014V48.6801L112.252 40.1793C112.971 39.7672 113.884 40.0196 114.294 40.7379C114.703 41.4572 114.453 42.3712 113.735 42.7811L96.5898 52.5588Z",
    fill: "#5C6366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5225 42.3834V49.3348L84.2068 52.0806V45.115L79.5225 42.3834Z",
    fill: "#A56F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3184 33.2169L79.5225 42.3635L84.265 45.0983L100.071 35.9565L95.3184 33.2169Z",
    fill: "#AD8461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.071 35.9565L95.3184 33.2169L79.5225 42.3635",
    fill: "#C99873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0438 45.0983V52.0806L99.9446 42.9031V35.9228L84.0438 45.0983Z",
    fill: "#633C21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.528 47.4433L112.676 50.9803L106.528 54.5632L100.38 50.9803L106.528 47.4433Z",
    fill: "#9FB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.38 50.9803L106.528 54.5632V116.713L100.38 113.163V50.9803Z",
    fill: "#576B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.38 50.9803L106.528 54.5632V116.713",
    fill: "#415556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.676 50.9803L106.528 54.5632V116.713L112.676 113.163V50.9803Z",
    fill: "#7E9091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.676 50.9803L106.528 54.5632V116.713",
    fill: "#728284"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 143,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/Bike.c8bbcad941db1b773435bae0ebf6f3dc.svg";
export { ForwardRef as ReactComponent };